import { IconChevronsLeft as TablerIconChevronsLeft } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconChevronsLeft = /*#__PURE__*/ createOutlineIcon(
  TablerIconChevronsLeft,
  'IconChevronsLeft',
);
